var _circle, _circle2, _path, _path2, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 111 98"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.542,
    cy: 47.989,
    r: 29.985,
    fill: "#12B76A",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.542,
    cy: 47.989,
    r: 23.812,
    fill: "#12B76A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m52.84 47.99 6.762 7.054 14.934-14.933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003079",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1.557 69.027c4.5 1.833 15.945 3.793 16.5-6.5.693-12.862-11.686-3.503-2 1 9.685 4.503 11.5-4.5 11.5-4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M93.057 21.004c3 0 9.2-1.7 10-8.5 1-8.5 5.5-8.5 6.5-8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4C36D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M87.557 79.004c2.666.333 8.1 2.9 8.5 10.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.057,
    cy: 45.504,
    r: 3.5,
    fill: "#003079"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.057,
    cy: 93.504,
    r: 3.5,
    fill: "#14A3BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.057,
    cy: 90.504,
    r: 1.5,
    fill: "#70C043"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.057,
    cy: 83.504,
    r: 3.5,
    fill: "#70C043"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.057,
    cy: 34.504,
    r: 3.5,
    fill: "#F4C36D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.057,
    cy: 3.504,
    r: 3.5,
    fill: "#C05DFE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.057,
    cy: 9.504,
    r: 1.5,
    fill: "#F8C264"
  })));
};
export default SvgSuccess;